export const add_success = 'Create succesfully!';
export const add_fail = 'Create failed!';
export const update_success = 'Update successfully!';
export const update_fail = 'Update failed!';
export const delete_success = 'Delete successfully!';
export const delete_fail = 'Delete failed!';
export const server_error = 'Server errors, please check the system!';